/**
 * @flow
 */

import React from 'react';
import styled from 'styled-components';
import { Menu as BaseMenu, Grid, Container } from 'semantic-ui-react';
import { Divider, PageHeader } from '../../../../components';
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';
import Search from '../../containers/service/service/Search';
import ServicesList from '../../containers/service/ServicesList';
import { AddServiceGroupButton } from './group';
import type { Intl } from '../../../../type';

type ServicesPageProps = { intl: Intl };

const Menu = styled(BaseMenu)`
    &.menu {
        margin: -0.5em -1em !important;
    }
`;

const intlMessages = defineMessages({
    manufacturerSearchPlaceholder: {
        id: 'pages.settings.services.search',
        defaultMessage: 'Search...',
    },
});

const ServicesSettings = ({ intl }: ServicesPageProps) => (
    <Container fluid>
        <Menu secondary>
            <BaseMenu.Item header>
                <PageHeader>
                    <FormattedMessage
                        id="pages.settings.services"
                        defaultMessage="Services Settings"
                    />
                </PageHeader>
            </BaseMenu.Item>
            <BaseMenu.Menu position="right">
                <BaseMenu.Item fitted>
                    <Search
                        icon="search"
                        placeholder={intl.formatMessage(
                            intlMessages.manufacturerSearchPlaceholder,
                        )}
                    />
                </BaseMenu.Item>
                <BaseMenu.Item>
                    <AddServiceGroupButton />
                </BaseMenu.Item>
            </BaseMenu.Menu>
        </Menu>
        <Divider />
        <Grid columns={1}>
            <Grid.Column>
                <ServicesList />
            </Grid.Column>
        </Grid>
    </Container>
);

export default injectIntl(ServicesSettings);
